import React, { memo } from 'react';
import TipOne from '@/pages/intelligence/assets/svg/tipicon/tip-one.svg';
import TipTwo from '@/pages/intelligence/assets/svg/tipicon/tip-two.svg';
import TipThree from '@/pages/intelligence/assets/svg/tipicon/tip-three.svg';

const RANK_MEDALS: Record<number, string> = {
  1: TipOne,
  2: TipTwo,
  3: TipThree,
};

export interface IRankCellProps {
  ranking?: number;
}

function RankCellInner({ ranking }: IRankCellProps) {
  if (ranking === undefined || ranking === null) {
    return null;
  }

  const medalSvg = RANK_MEDALS[ranking];

  return (
    <div className="dbom-x-hashtag-rank-cell">
      {medalSvg ? (
        <img
          className="dbom-x-hashtag-rank-cell__medal"
          src={medalSvg}
          alt={`#${ranking}`}
        />
      ) : (
        <span className="dbom-x-hashtag-rank-cell__number">{ranking}</span>
      )}
    </div>
  );
}

export default memo(RankCellInner);
